import React, { Component } from "react";
import { message } from "../messages.js";
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

class UseTokenForm extends Component
{
	state = {
		password: "",
		password_confirmation: "",
		submitting: false,
		errors: []
	}

	constructor (props) {
		super(props);
	}

	onSubmit = (e) => {
		e.preventDefault();

		const that = this;
		if (this.props.onSubmit) {
			let submitted = this.props.onSubmit({ password: this.state.password, password_confirmation: this.state.password_confirmation });
			if (submitted) {
				submitted.catch(function (errors) {
					that.setState({ errors: errors }, function () {
					});
				});
			}
		}
	}
	
	inputClass (input) {
		if (input in this.state.errors) {
			return "is-danger";
		}

		return "";
	}

	inputState (input) {
		if (input in this.state.errors) {
			return (
				<p className="help is-danger">{this.state.errors[input]}</p>
			);
		}

		return "";
	}

	render () {
		const onSubmit = false;

		return (
			<form onSubmit={this.onSubmit}>
				<div className="section">
					{message('INVITE_TEXT')}
				</div>
				<div className="field">
					<label className="label">Password</label>
					<div className="control has-icons-left">
						<input 
							required 
							type="input" 
							name="password" 
							className="input {this.inputClass('password')}" 
							type="password" 
							placeholder="Password" 
							onChange={(e) => { this.setState({ password: e.target.value })}}
						/>
				    <span className="icon is-small is-left">
				    	<FontAwesomeIcon icon="key" />
				    </span>
				    {this.inputState('password')}
					</div>
				</div>
				<div className="field">
					<label className="label">Repeat Password</label>
					<div className="control has-icons-left">
						<input 
							required 
							type="input" 
							name="password_confirmation" 
							className="input {this.inputClass('password_confirmation')}" 
							type="password" 
							placeholder="Repeat Password" 
							onChange={(e) => { this.setState({ password_confirmation: e.target.value })}}
						/>
				    <span className="icon is-small is-left">
				    	<FontAwesomeIcon icon="key" />
				    </span>
				    {this.inputState('password_confirmation')}
					</div>
				</div>
				<div className="field has-text-centered">
					<input type="submit" className="button" defaultValue="Use Token" />
					{this.inputState('credentials')}
				</div>
			</form>
		);
	}
}

export default UseTokenForm;


// WEBPACK FOOTER //
// ./src/Components/UseTokenForm.js